




















/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentStreamIssueTailoringBatchItemDTO } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
@Component(
	{
		name: "StreamTailorBatchItems"
	})
export default class StreamTailorBatchItems extends Vue {
	@Prop() private data: ContentStreamIssueTailoringBatchItemDTO[];
	private search: string = "";
	private headers: any = [
		{ text: "Tailor", value: "tailor" },
		{ text: "Amount", value: "amount" },
	];
}
